import type { ExplorationSecondary, ExplorationVolume } from '../types/exploration';

/** Tag grouping requires a chosen key; until then behave as no structural grouping. */
export function effectiveSecondary(
  secondary: ExplorationSecondary,
  tagKey: string | undefined
): ExplorationSecondary {
  if (secondary === 'tag' && !tagKey) return 'none';
  return secondary;
}

/** True when the user chose Volume Tag grouping but has not picked a key yet. */
export function isTagGroupingPending(
  secondary: ExplorationSecondary,
  tagKey: string | undefined
): boolean {
  return secondary === 'tag' && !tagKey;
}

export function isRegionOrTagSecondary(secondary: ExplorationSecondary): boolean {
  return secondary === 'region' || secondary === 'tag';
}

/** Region/tag structural grouping after applying the tag-key requirement. */
export function isEffectiveRegionOrTagSecondary(
  secondary: ExplorationSecondary,
  tagKey: string | undefined
): boolean {
  const resolved = effectiveSecondary(secondary, tagKey);
  return resolved === 'region' || resolved === 'tag';
}

export function secondaryBucketKey(
  volume: ExplorationVolume,
  secondary: 'region' | 'tag',
  tagKey: string
): string {
  if (secondary === 'region') return volume.region || '(unknown)';
  return (volume.tags && tagKey && volume.tags[tagKey]) || '(untagged)';
}
